import { Spinner, Text, View } from '@gluestack-ui/themed'
import React, { FunctionComponent, useEffect } from 'react'
import { StyleSheet, Switch } from 'react-native'
import { useDispatch, useSelector } from 'react-redux'
import { NotificationUserCategorie } from '../../api/Notification/types'
import { LeftButtonBack, Page } from '../../components/Page'
import { i18n } from '../../lib/i18n'
import { isLoadingSelector } from '../../redux/loading/selectors'
import { LoaderName } from '../../redux/loading/types'
import { NotificationActions } from '../../redux/notification/action'
import { notificationSettingsSelector } from '../../redux/notification/selector'
import { RootState } from '../../redux/reducers'
import { themeSelector } from '../../redux/theme/selector'
import { trackEvent } from '../../services/matomo/matomo.service'
import { theme } from '../../theme/theme'

export const NotificationSettings: FunctionComponent = () => {
  const dispatch = useDispatch()
  const settings = useSelector(notificationSettingsSelector)
  const themeResult = useSelector(themeSelector)
  const isLoading = useSelector((state: RootState) => isLoadingSelector(state, LoaderName.LOAD_NOTIFICATION_SETTINGS))

  const primaryColor = themeResult?.brandPrimary || theme.colors.blue

  useEffect(() => {
    dispatch(NotificationActions.loadNotificationsSettings())
  }, [])

  console.log(primaryColor)

  const allEnabled = (
    <View style={styles.line}>
      <Text>{i18n.t('notifications.categorieAll')}</Text>
      <Switch
        value={settings.enabled}
        trackColor={{ false: theme.colors.silver, true: primaryColor }}
        thumbColor={theme.colors.white}
        onValueChange={(value: boolean) => {
          dispatch(NotificationActions.notificationSettingsEnabled(value))
          trackEvent({
            category: 'Notifications',
            actionName: 'Notifications',
            eventName: `Modification paramètre`,
            value: `${i18n.t('notifications.categorieAll')}: ${value ? 'Oui' : 'Non'}`,
          })
        }}
      />
    </View>
  )

  const renderCategory = (item: NotificationUserCategorie) => (
    <View style={styles.line} key={item.id}>
      <Text>{item.categorie.libelle}</Text>
      <Switch
        value={item.notifier}
        trackColor={{ false: theme.colors.silver, true: primaryColor }}
        thumbColor={theme.colors.white}
        onValueChange={(value: boolean) => {
          dispatch(NotificationActions.notificationCategorieEnabled(item.id, value))
          trackEvent({
            category: 'Notifications',
            actionName: 'Notifications',
            eventName: `Modification d'un paramètre`,
            value: `${item.categorie.libelle}: ${value ? 'Oui' : 'Non'}`,
          })
        }}
      />
    </View>
  )

  const RenderCategories: FunctionComponent = () => (settings.enabled ? <>{settings.categories.map(renderCategory)}</> : <View />)

  const RenderContent: FunctionComponent = () => {
    if (isLoading) {
      return <Spinner />
    }

    return (
      <View>
        <Text style={styles.message}>{settings.message}</Text>
        {allEnabled}
        <RenderCategories />
      </View>
    )
  }

  return (
    <Page left={<LeftButtonBack />} title={i18n.t('notifications.settingTitle')}>
      <RenderContent />
    </Page>
  )
}

const styles = StyleSheet.create({
  line: {
    borderColor: theme.colors.paleGrey,
    borderWidth: 1,
    flexDirection: 'row',
    justifyContent: 'space-between',
    padding: theme.padding.x2,
  },
  message: {
    textAlign: 'center',
    width: '100%',
    padding: theme.padding.x2,
  },
})
